import React from 'react';
import Button from '@atlaskit/button';
import { FAILED_FIELD_STATE } from '@atlassian/jira-forge-controllers-inline-fields-state/src/constants.tsx';
import { useInlineField } from '@atlassian/jira-forge-controllers-inline-fields-state/src/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	fieldId: string;
};

export const ForgeFieldDispatchButton = (props: Props): React.JSX.Element | null => {
	const { fieldId } = props;
	const [fieldState, { dispatchRetryFunction }] = useInlineField(fieldId);
	const { formatMessage } = useIntl();

	const onClickHandler = async () => {
		if (fieldId !== undefined) {
			await dispatchRetryFunction(fieldId);
		}
	};

	const renderRetryButton = () => {
		if (fieldState !== undefined && fieldState?.status === FAILED_FIELD_STATE) {
			return (
				<Button spacing="none" appearance="link" onClick={onClickHandler}>
					{formatMessage(messages.forgeRetryButton)}
				</Button>
			);
		}

		return null;
	};

	return renderRetryButton();
};
